import { request } from 'graphql-request'
const fetcher = query => request(process.env.REACT_APP_GRAPHQL_API, query)
export default fetcher